<template>
  <el-dialog
    :visible.sync="$store.state.loginDialogVisible"
    :show-close="false"
    class="login-dialog"
    width="420px"
    :close-on-click-modal="false"
  >
    <div class="login-box">
      <!-- 头部 -->
      <div class="login-header">
        <div class="login-logo">
          <i class="el-icon-user-solid"></i>
        </div>
        <h3 class="login-title">欢迎登录</h3>
        <p class="login-subtitle">请输入您的账号和密码</p>
      </div>

      <!-- 表单 -->
      <el-form ref="userLoginRef" :model="userLogin" :rules="userLoginRules" class="login-form">
        <el-form-item prop="username">
          <div class="input-group">
            <i class="el-icon-user input-icon"></i>
            <el-input
              v-model="userLogin.username"
              placeholder="请输入用户名"
              class="custom-input"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="password">
          <div class="input-group">
            <i class="el-icon-lock input-icon"></i>
            <el-input
              type="password"
              v-model="userLogin.password"
              placeholder="请输入密码"
              class="custom-input"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="captcha">
          <div class="captcha-row">
            <div class="input-group captcha-input-wrap">
              <i class="el-icon-s-check input-icon"></i>
              <el-input
                v-model="userLogin.captcha"
                placeholder="请输入验证码"
                class="custom-input"
                @keyup.enter.native="login"
              ></el-input>
            </div>
            <img
              :src="'data:image/jpeg;base64,' + captchaBase64"
              @click="getCaptcha"
              class="captcha-img"
              title="点击刷新验证码"
            />
          </div>
        </el-form-item>
      </el-form>

      <!-- 按钮 -->
      <div class="login-footer">
        <button class="btn-login" @click="login">
          <i class="el-icon-right"></i>
          登 录
        </button>
        <button class="btn-cancel" @click="resetForm">取 消</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {login, getUserInfo} from "@/api/user";
import {getCaptcha} from "@/api/index";
import {setToken, setLocalUserInfo} from "@/utils/auth";

export default {
  name: 'login-dialog',
  data() {
    return {
      captchaBase64: '',
      userLogin: {
        username: '',
        password: '',
        captcha: '',
        uuid: '',
        rememberMe: false
      },
      userLoginRules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur'}
        ],
        captcha: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.getCaptcha();
  },
  methods: {
    getCaptcha() {
      getCaptcha().then(res => {
        this.captchaBase64 = res.data.img;
        this.userLogin.uuid = res.data.uuid;
      });
    },
    resetForm() {
      this.$refs.userLoginRef.resetFields();
      this.$store.dispatch('setLoginDialog', false);
    },
    login() {
      this.$refs.userLoginRef.validate((valid) => {
        if (!valid) return;
        login(this.userLogin.username, this.userLogin.password, this.userLogin.captcha, this.userLogin.uuid).then(res => {
          setToken(res.data);
          getUserInfo().then(res1 => {
            setLocalUserInfo(res1.data);
          });
          this.resetForm();
          this.$message.success(res.message);
        });
      });
    }
  }
};
</script>

<style scoped>
.login-box {
  padding: 8px 4px 4px;
}

/* 头部 */
.login-header {
  text-align: center;
  margin-bottom: 24px;
}

.login-logo {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(135deg, #4f6ef7, #7b95fa);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin: 0 auto 12px;
  box-shadow: 0 6px 20px rgba(79, 110, 247, 0.35);
}

.login-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 6px;
}

.login-subtitle {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

/* 表单 */
.login-form {
  margin-bottom: 16px;
}

.input-group {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
  font-size: 16px;
  z-index: 1;
  pointer-events: none;
}

/* 验证码行 */
.captcha-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-input-wrap {
  flex: 1;
}

.captcha-img {
  height: 38px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  flex-shrink: 0;
  transition: opacity 0.3s;
}

.captcha-img:hover {
  opacity: 0.85;
}

/* 底部按钮 */
.login-footer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 4px;
}

.btn-login {
  width: 100%;
  height: 42px;
  background: linear-gradient(135deg, #4f6ef7, #7b95fa);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.3s, transform 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-login:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.btn-cancel {
  width: 100%;
  height: 38px;
  background: transparent;
  color: #94a3b8;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-cancel:hover {
  border-color: #4f6ef7;
  color: #4f6ef7;
  background: rgba(79, 110, 247, 0.04);
}
</style>

<style>
/* 覆盖 el-dialog 样式 */
.login-dialog .el-dialog {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.login-dialog .el-dialog__header {
  display: none;
}

.login-dialog .el-dialog__body {
  padding: 28px 28px 24px;
}

/* 输入框左内边距增大以给 icon 留空间 */
.login-dialog .custom-input .el-input__inner {
  padding-left: 36px;
  border-radius: 8px;
  border-color: #e2e8f0;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.login-dialog .custom-input .el-input__inner:focus {
  border-color: #4f6ef7;
  box-shadow: 0 0 0 3px rgba(79, 110, 247, 0.1);
}
</style>
